import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { ArticleListItem } from "../hooks/useArticles";
import ArticleList from "../components/ArticleList";

export default function Category() {
  const { categoryName } = useParams<{ categoryName: string }>();
  const [articles, setArticles] = useState<ArticleListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [categoryInfo, setCategoryInfo] = useState<{
    id: number;
    name: string;
    description: string | null;
  } | null>(null);

  useEffect(() => {
    async function fetchCategoryArticles() {
      if (!categoryName) return;

      setLoading(true);

      // カテゴリ情報を取得
      const { data: category } = await supabase
        .from("categories")
        .select("id, name, description")
        .ilike("name", `%${categoryName}%`)
        .single();

      if (!category) {
        setLoading(false);
        return;
      }

      setCategoryInfo(category);

      // カテゴリに紐づく記事を取得
      const { data: articleCategories } = await supabase
        .from("article_categories")
        .select(
          `
          article_id,
          relevance_score,
          matched_keywords,
          articles!inner (
            id,
            title,
            url,
            published_at,
            summary,
            priority,
            is_relevant,
            sources!inner (
              name
            )
          )
        `,
        )
        .eq("category_id", category.id)
        .order("relevance_score", { ascending: false })
        .limit(50);

      const mappedArticles: ArticleListItem[] = (articleCategories || []).map(
        (ac: any) => ({
          id: ac.articles.id,
          title: ac.articles.title,
          url: ac.articles.url,
          published_at: ac.articles.published_at,
          summary: ac.articles.summary,
          priority: ac.articles.priority,
          relevance_score: ac.relevance_score,
          is_relevant: ac.articles.is_relevant,
          source_name: ac.articles.sources?.name,
          categories: [
            {
              category_id: category.id,
              category_name: category.name,
              relevance_score: ac.relevance_score,
              matched_keywords: ac.matched_keywords?.split(",") || [],
            },
          ],
        }),
      );

      setArticles(mappedArticles);
      setLoading(false);
    }

    fetchCategoryArticles();
  }, [categoryName]);

  return (
    <div className="space-y-6">
      {/* ヘッダー */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          {categoryInfo?.name || categoryName}
        </h1>
        {categoryInfo?.description && (
          <p className="mt-1 text-sm text-gray-500">
            {categoryInfo.description}
          </p>
        )}
        <p className="mt-1 text-sm text-gray-500">{articles.length}件の記事</p>
      </div>

      {/* 記事一覧 */}
      <ArticleList
        articles={articles}
        loading={loading}
        emptyMessage={`${categoryName}カテゴリの記事がありません`}
      />
    </div>
  );
}
